<template>
  <v-card max-width="100%" class="pa-0 ma-2 mt-16 elevation-0" flat>
    <v-row align="center">
      <v-card-text style="text-align: center; font-size: 20px"
        ><b>Work in Progress</b>
      </v-card-text>
    </v-row>
    <!-- <v-data-table
        dense
        :headers="headers"
        :items="itemsub"
        label="Subscription"
        item-key="name"
      >
        <template v-slot:top>
          <v-layout row wrap class="mb-2">
            <v-row>
              <v-col cols="3">
                <v-card-title class="ml-2 primary--text">
                  Billing Report
                
                </v-card-title>
              </v-col>
              <v-spacer />
              <v-col cols="3" class="mt-4 ml-2">
                <v-text-field
                  v-model="search"
                  shaped
                  outlined
                  dense
                  class="mt-n1"
                  color="primary"
                  append-icon="mdi-magnify"
                  label="Search"
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-layout>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon @click="viewemp(item)" v-on="on" color="primary"
                >mdi-download</v-icon
              >
            </template>
            <span>Download</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                small
                @click="viewemp(item)"
                class="ml-2"
                v-on="on"
                color="primary"
                >mdi-eye</v-icon
              >
            </template>
            <span>view details</span>
          </v-tooltip>
        </template>

      
      </v-data-table> -->
    <!-- <template v-slot:item.actions="{ item }">
             <v-tooltip bottom>
            <template v-slot:activator="{on}">
          <v-icon small @click="viewemp(item)"    v-on="on"  color="primary">mdi-file-download</v-icon>
        </template>
         <span>view details</span>
          </v-tooltip>
         </template> -->
  </v-card>
</template>
<script>
import { apiCall } from "@/Views/APICALL/APIcall.js";

export default {
  components: {},
  data: () => ({
    addsubscription: false,
    itemsub: [
      {
        sl_no: "1",
        corp_name: "rij_cor",
        user_det: "xyz",
        txn_name: "700(MYR)",
        txn_amount: "24/07/01",
        bal_left: "100(MYR)",
        txn_status_message: "1200(MYR)",
        txn_status: "",
      },
    ],
    headers: [
      { text: "SL NO", value: "sl_no" },
      {
        text: "PACK NAME",
        align: "start",
        value: "user_det",
        sortable: false,
      },
      {
        text: "MONTHLY BILLING FEE",
        align: "start",
        sortable: false,
        value: "txn_name",
        width: "200px",
      },

      { text: "MONTHLY BILLING DATE", value: "txn_amount", sortable: false },
      { text: "Suspension Fee", value: "bal_left", sortable: false },

      {
        text: "ANNUAL BILLING FEE",
        value: "txn_status_message",
        sortable: false,
      },
      { text: "ACTIONS", value: "actions", align: "start", sortable: false },
    ],
  }),
  created() {
    this.checkacces();
  },
  methods: {
    opensubscriptiondialog() {
      this.addsubscription = true;
    },
    async checkacces() {
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CHECK_ACCESS",
          user_id: this.$store.getters.get_userid,
          module_code: "CUSERS",
          module_type: "2",
        },
      };
      var responseData = await apiCall(inputData);
      //  console.log(responseData, "responsCHECK_ACCESSeData");
      var checkaccessdata = responseData.data.data;
      // checkaccessdata.is_approver = false;
      // checkaccessdata.is_checker = false;
      // checkaccessdata.is_maker = false;
      // checkaccessdata.is_viewer = false;
      if (
        checkaccessdata.is_approver == false &&
        checkaccessdata.is_checker == false &&
        checkaccessdata.is_maker == false &&
        checkaccessdata.is_viewer == false
      ) {
        this.$router.push("/accessdenied");
      }
    },
  },
};
</script>